module.exports = __webpack_public_path__ + "img/belgium-neoplasm-female.a2036ff7.png";